import { ReactElement } from 'react'
import DriverCashCollect from '../../components/Driver/CashCollection'
import Layout from '../../components/layout'

const DriversCashCollectPage = (): ReactElement => {
  return (
    <Layout>
      <DriverCashCollect />
    </Layout>
  )
}

export default DriversCashCollectPage
